
  import { SuccessDialogPlugin } from '@/plugins/GlobalDialog'
  import { Component, Vue } from 'vue-property-decorator'
  import SuccessDialogEvent from '@/plugins/GlobalDialog/models/interfaces/SuccessDialogEvent'

  @Component
  export default class SuccessDialog extends Vue {
    private message: string = ''
    private visible: boolean = false
    private onConfirm: VoidFunction|false = false

    private beforeMount(): void {
      SuccessDialogPlugin.$eventBus.$on('show-success-dialog', (params: SuccessDialogEvent) => {
        this.show(params.message, params.onConfirm)
      })
    }

    private hide(): void {
      this.visible = false
    }

    private confirm(): void {
      if (typeof this.onConfirm === 'function') {
        this.onConfirm()
      }

      this.hide()
    }

    private show(message: string, onConfirm?: VoidFunction): void {
      this.visible = true
      this.message = message

      if (onConfirm) {
        this.onConfirm = onConfirm;
      }
    }
  }
